import React from "react";
import { Field, ErrorMessage } from "formik";
import { FaShieldAlt } from "react-icons/fa";
import Rules from "../components/Rules";
import AssociationDocs from "../components/AssociationDocs";
import SectionCard from "../components/SectionCard";
import { Checkbox } from "../components/ui/checkbox";

export const StepLegal = ({ isBenevole = false }) => (
  <div className="flex flex-col gap-3 step-enter">
    <div>
      <h2 className="text-base font-bold text-foreground">Règlement & données</h2>
      <p className="text-xs text-muted-foreground mt-0.5">Ce que dit la loi, et ce qu'on fait de tes infos.</p>
    </div>

    {/* Règlement intérieur */}
    <div className="flex flex-col gap-1.5">
      <Field name="reglementInterieurLu">
        {({ field, form }) => (
          <label className="rrow" data-on={field.value === true}>
            <Checkbox
              id="reglementInterieurLu"
              checked={field.value === true}
              onCheckedChange={(v) => form.setFieldValue("reglementInterieurLu", v)}
              className="mt-0.5"
            />
            <div className="flex-1">
              <div className="flex items-center justify-between gap-4">
                <span className="text-sm font-semibold leading-snug">
                  Le règlement intérieur est lu et approuvé.{" "}
                  <span style={{ color: "var(--req)" }}>*</span>
                </span>
                <Rules />
              </div>
            </div>
          </label>
        )}
      </Field>
      <ErrorMessage name="reglementInterieurLu" component="p" className="field-err" />
    </div>

    <AssociationDocs isBenevole={isBenevole} />

    {/* Droit à l'image — consentement exprès (opt-in), distinct de l'acceptation du règlement */}
    <div className="flex flex-col gap-1.5">
      <Field name="imageRightsConsent">
        {({ field, form }) => (
          <label className="rrow" data-on={field.value === true}>
            <Checkbox
              id="imageRightsConsent"
              checked={field.value === true}
              onCheckedChange={(v) => form.setFieldValue("imageRightsConsent", v)}
              className="mt-0.5"
            />
            <div className="flex-1">
              <span className="text-sm font-semibold leading-snug">
                J'autorise ImagiGeeks à utiliser mon image (photos, vidéos) pour communiquer sur ses activités
                (réseaux sociaux, flyers, site internet).
              </span>
              <p className="text-[11px] text-muted-foreground mt-0.5">
                Facultatif — sans cette autorisation, ton image ne sera pas utilisée. Retrait possible à tout
                moment par simple message au Président.
              </p>
            </div>
          </label>
        )}
      </Field>
    </div>

    {/* RGPD */}
    <SectionCard title="Vos données personnelles" icon={FaShieldAlt}>
      <p className="text-[11px] text-muted-foreground leading-snug">
        <strong className="text-foreground">Responsable :</strong> association ImagiGeeks (loi 1901), 21 Cité du
        Général Leclerc, 02830 Saint-Michel — RNA W025004874 · SIRET 937 488 955 00017 —{" "}
        <a href="mailto:contact@imagigeeks.org" className="text-primary underline underline-offset-2">
          contact@imagigeeks.org
        </a>
        .
      </p>
      <p className="text-[11px] text-muted-foreground leading-snug">
        <strong className="text-foreground">Finalité :</strong> gestion de l'adhésion et de la vie associative.{" "}
        <strong className="text-foreground">Conservation :</strong> durée de l'adhésion + 3 ans.{" "}
        <strong className="text-foreground">Droits :</strong> accès, rectification, effacement, opposition — par
        message à l'adresse ci-dessus, ou réclamation auprès de la{" "}
        <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-primary underline underline-offset-2">
          CNIL
        </a>
        .
      </p>
    </SectionCard>
  </div>
);
